import { render } from "./shapes.vue?vue&type=template&id=b389af24"
import script from "./shapes.vue?vue&type=script&lang=js"
export * from "./shapes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__